import * as React from 'react';

function UnassignCredentialIcon({ color = '#545454', ...props }) {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={16} height={16} viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2m20-10h-6m-3-4a4 4 0 11-8 0 4 4 0 018 0z'
				stroke={color}
				strokeWidth={2}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}

export default UnassignCredentialIcon;
